import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector, createSelector } from '@ngxs/store';
import {
  BorrowerStatusesService,
  BorrowerStatusOption,
} from 'ng2-app/store/borrowerStatuses/borrower-statuses.service';
import { GetBorrowerStatuses } from 'ng2-app/store/borrowerStatuses/borrower-statuses.action';
import { catchError, of, tap } from 'rxjs';

export class BorrowerStatusesStateModel {
  statusOptions: BorrowerStatusOption[];
}

@State<BorrowerStatusesStateModel>({
  name: 'BorrowerStatuses',
  defaults: {
    statusOptions: [],
  },
})
@Injectable()
export class BorrowerStatusesState {

  @Selector()
  static statusOptions( state: BorrowerStatusesStateModel ) {
    return state.statusOptions;
  }

  @Selector()
  static optionByStatusAlias( alias: string ) {
    return createSelector([ BorrowerStatusesState ], ( {BorrowerStatuses} ) => {
      return BorrowerStatuses.statusOptions.filter( option => option.status === alias)[0] || null;
    });
  }

  @Selector()
  static nurtureStatusOptions( state: BorrowerStatusesStateModel ) {
    return state.statusOptions.filter( (option: BorrowerStatusOption) => {
      return option.borrower_stage_lookup.stage === 'inactive' &&
        !option.deprecated;
    });
  }

  constructor(
    private statusService: BorrowerStatusesService,
  ) {}

  @Action( GetBorrowerStatuses )
  getBorrowerStatuses(
    { setState }: StateContext<BorrowerStatusesStateModel>,
    { }: GetBorrowerStatuses
  ) {
    return this.statusService.get()
      .pipe(
        catchError(() => {
          return of([]);
        }),
        tap( (statusOptions: BorrowerStatusOption[]) => {
          setState({
            statusOptions
          });
        })
      );
  }

}
